import { NovuProvider } from '@novu/notification-center';

import { useSession } from 'next-auth/react';

const CustomNovuProvider = ({
  children,
  mockNovuObj, // used by SB
}: {
  children: any;
  backendUrl?: string;
  mockNovuObj?: {
    subscriber_id: string,
    subscriber_hash: string,
  }
}) => {
  const session = useSession();

  // @ts-ignore
  const novuObj = session?.data?.novu || mockNovuObj;
  const { subscriber_hash, subscriber_id } = novuObj || {};

  // console.log('subscriber_id ', subscriber_id);
  // console.log('subscriber_hash ', subscriber_hash);

  return (
    <NovuProvider
      socketUrl={process?.env?.NOVU_SOCKET_BACKEND_URL}
      subscriberId={subscriber_id}
      subscriberHash={subscriber_hash}
      // @ts-ignore
      applicationIdentifier={process?.env?.NOVU_IDENTIFIER}
      backendUrl={process?.env?.NOVU_BACKEND_URL}
      initialFetchingStrategy={{
        fetchNotifications: true,
        fetchUserPreferences: true,
        fetchUnseenCount: true,
      }}
      stores={[
        { storeId: 'unseen', query: {seen: false} },
        { storeId: 'all', query: {} },
      ]}
      i18n={{
        lang: 'sv-SE',
        translations: {
          markAsRead: 'Avmarkera',
          markAsUnRead: 'Markera',
          removeMessage: 'Radera post',
          noNewNotification: 'Inget nytt att se här än',
        }
      }}
    >
      {children}
    </NovuProvider>
  );
};

export default CustomNovuProvider;
